import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Global 402 (upgrade-required) handling: route to an in-context upgrade modal.
let upgradeHandler = null;
export const setUpgradeHandler = (fn) => { upgradeHandler = fn; };

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 402) {
      const detail = error.response.data?.detail;
      const msg = typeof detail === "string" ? detail : "This feature requires an upgrade.";
      const plan = /pro/i.test(msg) ? "pro" : "plus";
      if (upgradeHandler) upgradeHandler({ message: msg, plan });
      error.handledUpgrade = true; // callers skip their own toast
    }
    return Promise.reject(error);
  }
);

export function apiError(detail, fallback = "Something went wrong.") {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
